/**
 * O site público, que mora em outro domínio.
 *
 * O backoffice precisa dele por um motivo só, e é o motivo pelo qual Provas
 * para Imprimir existe: **o link é o produto**. Quem libera uma prova precisa
 * copiar dali o endereço que vai mandar a quem pediu o PDF, e um endereço
 * montado à mão na cabeça de quem responde é o endereço que sai errado.
 *
 * Espelho do `site.ts` do app, pelo mesmo motivo que ele existe lá.
 */
const SITE = import.meta.env.VITE_SITE_URL ?? 'https://titularis.com.br';

/** A página pública de uma prova liberada. */
export const enderecoDaProva = (slug: string): string =>
  `${SITE}/provas/${encodeURIComponent(slug)}`;

export const enderecoDoArtigo = (slug: string): string =>
  `${SITE}/revista/artigo/${encodeURIComponent(slug)}`;

/** A página pública de um material grátis. */
export const enderecoDoMaterial = (slug: string): string =>
  `${SITE}/materiais/${encodeURIComponent(slug)}`;

/**
 * O endereço que vai dentro do PDF, para quem gera o arquivo.
 *
 * No `www`, e não no domínio sem ele: é o endereço canônico do site, e o que a
 * marca de cópia reconhece nos dois casos.
 */
export const enderecoDoLink = (slug: string, chave: string): string =>
  `https://www.titularis.com.br/materiais/${encodeURIComponent(slug)}/l/${encodeURIComponent(chave)}`;
